import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { iusuario } from '../models/iusuario.model';
import { ROUTES_ARCHIVOS } from '../constants/constant.model';
import { iSucursal } from '../models/isucursalmodel'
import { ImagenBase64 } from '../models/imagenBase64.model';

import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
@Injectable({
    providedIn: 'root'
})
export class SucursalService {

    constructor(private apiService: ApiService, private http: HttpClient) { }

    buscarSucursal(): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.sucursal_buscar_url);
        return this.apiService.execGetQueryJson('');
    }
    
    buscarSucursal_v2(): Observable<any> {
        this.apiService.setUrlPathERPApi(ROUTES_ARCHIVOS.sucursal_buscar_url);
        return this.apiService.execGetQueryJson('');
    }

    insertarSucursal(data: iSucursal): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.sucursal_insertar_url);
        return this.apiService.executePostJson(data).pipe();
    }

    actualizarSucursal(data: iSucursal): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.sucursal_actualiza_url);
        return this.apiService.executePutJson(data).pipe();
    }

    eliminarSucursal(data: iSucursal): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.sucursal_eliminar_url);
        return this.apiService.executeDeleteJson(data).pipe();
    }

    obtenerSucursal(codsuc: string): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.sucursal_obtener_url);
        return this.apiService.execGetQueryJson(`${codsuc}`)
    }

    //-----------------SERVICIOS DE CLASES SUCURSALES------------------

    eliminarClase(codsuc: string, clase: string): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.clase_sucursal_eliminarclase);
        return this.apiService.executeDeleteJson(`${codsuc}/clase/${clase}`)
    }

    obtenerClases(): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.clase_sucursal_obtenerclases);
        return this.apiService.execGetJson()
    }

    obtenerClase(codsuc: string, clase: string): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.clase_sucursal_obtener);
        return this.apiService.execGetQueryJson(`${codsuc}/clase/${clase}`)
    }

    // ---- SERVICIOS SUCURSLA TIPO IMAGEN --------------------

    insertarImagenSucursalTipoImagen(request:any): Observable<any> {
        this.apiService.setUrlPathApi(`sucursal-tipo-imagen`);
        return this.apiService.executePostJson(request).pipe();
    }

    updateImagenSucursalTipoImagen(request:any): Observable<any> {
        this.apiService.setUrlPathApi(`sucursal-tipo-imagen`);
        return this.apiService.executePutJson(request).pipe();
    }

    deleteImagenSucursalTipoImagen(codsuc: number, tipo: string): Observable<any> {
        this.apiService.setUrlPathApi(`sucursal-tipo-imagen`);
        return this.apiService.executeDeleteJson(`?codsuc=${codsuc}&idtipo=${tipo}`)
    }

    getImagenSucursalTipoImagen(codsuc: number, idtipo: string): Observable<any> {
        this.apiService.setUrlPathApi(`sucursal-tipo-imagen/logo`);
        return this.apiService.execGetQueryJson(`?codsuc=${codsuc}&idtipo=${idtipo}`)
    }

    //-----------------SERVICIOS DE IMAGEN SUCURSALES------------------

    insertarImagenSucursal(codsuc: string, imagenBase64: ImagenBase64): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.imagen_sucursal_insertar + codsuc + '/imagen');
        return this.apiService.executePutJson(imagenBase64).pipe();
    }

    obtenerImagenSucursal(codsuc: string, tipo: string, cia: string): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.imagen_sucursal_obtener + codsuc + '/public/imagen/' + tipo);
        return this.apiService.execGetQueryJson(`?cia=${cia}.jpg`)
    }

    deleteImagenSucursal(codsuc: string, tipo: string): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.imagen_sucursal_eliminar);
        return this.apiService.executeDeleteJson(`${codsuc}/imagen/${tipo}`)
    }

    obtenerImagenSucursal2(codsuc: string, tipo: string, cia: string): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.imagen_sucursal_obtener + codsuc + '/logo/' + tipo);
        return this.apiService.execGetQueryJson(``)
    }

    obtenerListadoClasesSucursal(): Observable<any> {
        this.apiService.setUrlPathApi('clases-genericas');
        return this.apiService.execGetQueryJson(`/sucursal/clases`)
        /* `/plan-cuentas/clases` */
    }
    obtenerClasesPorSucursal(codigoSucursal:number): Observable<any> {
        this.apiService.setUrlPathApi('sucursal');
        return this.apiService.execGetQueryJson(`/clases?codsuc=${codigoSucursal}`)
    }

    insertarClasePorSucursal(codigoSucursal:number, sender:any): Observable<any> {
        this.apiService.setUrlPathApi(`sucursal/${codigoSucursal}/clase`);
        return this.apiService.executePostJson(sender).pipe();
    }
    actualizarClaseSucursal(codigoSucursal:number, sender:any): Observable<any> {
        this.apiService.setUrlPathApi(`sucursal/${codigoSucursal}/clase`);
        return this.apiService.executePutJson(sender).pipe();
    }
} 